import { render } from "./MusubiComposeModal.vue?vue&type=template&id=0b7bb130&scoped=true"
import script from "./MusubiComposeModal.vue?vue&type=script&lang=js"
export * from "./MusubiComposeModal.vue?vue&type=script&lang=js"

import "./MusubiComposeModal.vue?vue&type=style&index=0&id=0b7bb130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7bb130"]])

export default __exports__